module.exports = __webpack_public_path__ + "img/logo.e4769dda.png";